import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { VesselsService } from '../../../../../services/vessels.service';
import { DatePipe } from '@angular/common';
import { StorageService } from '../../../../../services/storage.service';
import { PoolingPortalService } from '../../../../../services/pooling-portal.service';
import { AddEditPenaltyModel, Setting } from '../../../../../interface/fleetList.interface';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-add-edit-penalty',
  templateUrl: './add-edit-penalty.component.html',
  styleUrls: ['./add-edit-penalty.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddEditPenaltyComponent {
  eventEmitter: any;

  @Input() iAddPenaltyForm: any;
  @Input() iEditPenaltyForm: any;
  @Input() iPenaltyForm: any;
  @Input() shipDetail: any;
  @Output() closePenality = new EventEmitter();


  public penaltyForm: UntypedFormGroup;

  viewModel: AddEditPenaltyModel  = {
    submit:false,
    isClosePenaltyChecked: false,
    isPenaltyFormChanged:false,
    minDate: new Date(),
    effectiveFormDate:new Date(),
    closeEffectiveDate:new Date(),
  }
  setting:Setting  = {
    showCloseIcon: false, 
    backdropClick: false
  } 
  
  constructor(
    private fb: UntypedFormBuilder,
    private _vesselService: VesselsService,
    public datepipe: DatePipe,
    private toasterService: ToasterService,
    private _storageService: StorageService,
    private _poolingPortalService: PoolingPortalService,
  ) {
  }

  createPenaltyForm() {

    const today =  new Date();
    const tomorrow =  new Date(today.setDate(today.getDate() + 1));

    let effectiveDate: any = this.datepipe.transform(tomorrow, 'yyyy-MM-dd');
    let effectiveForm = effectiveDate.split("-");
    let effectiveFormDate = effectiveForm[2] + '.' + effectiveForm[1] + '.' + effectiveForm[0];
    this.viewModel.effectiveFormDate = new Date(effectiveForm[0] + '-' + effectiveForm[1] + '-' + effectiveForm[2]);

    this.penaltyForm = this.fb.group({
      penalty: ['', [Validators.required, Validators.max(this.shipDetail?.poolPoint), Validators.pattern("^[0-9]{0,3}(([\\.]{1}[0-9]{0,3})|())$")]],
      effectiveFormDate: [effectiveFormDate, Validators.required],
      effectiveFormTime: ['00:00', Validators.required],
      reason: [''],
    });
  }

  createUpdatePenaltyForm() {
    this.penaltyForm = this.fb.group({
      penalty: ['', [Validators.required, Validators.max(this.shipDetail?.poolPoint), Validators.pattern("^[0-9]{0,3}(([\\.]{1}[0-9]{0,3})|())$")]],
      effectiveFormDate: ['', Validators.required],
      effectiveFormTime: ['00:00', Validators.required],
      reason: [''],
      closeEffectiveDate: [''],
      closeEffectiveTime: ['00:00'],
    });
  }

  get p() { return this.penaltyForm.controls; }

  ngOnInit() {
   
    let date = new Date();
    this.viewModel.minDate = new Date((date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + (date.getDate()));
    if (this.iAddPenaltyForm) {
      this.createPenaltyForm();
    }
    else {
      this.createUpdatePenaltyForm();
      if (this.shipDetail?.penaltyCloseEffectiveDate) {
        this.viewModel.isClosePenaltyChecked = true;
        this.penaltyForm.controls["closeEffectiveDate"].setValidators([Validators.required]);
        this.penaltyForm.controls["closeEffectiveTime"].setValidators([Validators.required]);
      }

      let closeEffectiveDate = '';
      let effectiveFormDate = '';

      if (this.shipDetail?.penaltyEffectiveDate) {
        let effectiveDate: any = this.datepipe.transform(this.shipDetail.penaltyEffectiveDate, 'yyyy-MM-dd');
        let effectiveForm = effectiveDate.split("-");
        effectiveFormDate = effectiveForm[2] + '.' + effectiveForm[1] + '.' + effectiveForm[0];
        this.viewModel.effectiveFormDate = new Date(effectiveForm[0] + '-' + effectiveForm[1] + '-' + effectiveForm[2]);
      }


      if (this.shipDetail?.penaltyCloseEffectiveDate) {
        let closeEffective: any = this.datepipe.transform(this.shipDetail.penaltyCloseEffectiveDate, 'yyyy-MM-dd');
        let closeEffectiveFrom = closeEffective.split("-");
        closeEffectiveDate = closeEffectiveFrom[2] + '.' + closeEffectiveFrom[1] + '.' + closeEffectiveFrom[0];
        this.viewModel.closeEffectiveDate = new Date(closeEffectiveFrom[0] + '-' + closeEffectiveFrom[1] + '-' + closeEffectiveFrom[2]);
      }
      this.penaltyForm.patchValue({
        penalty: String(this.shipDetail?.penaltyValue),
        effectiveFormDate: effectiveFormDate,
        effectiveFormTime: this.shipDetail?.penaltyEffectiveTime,
        reason: this.shipDetail?.penaltyReason,
        closeEffectiveDate: closeEffectiveDate,
        closeEffectiveTime: this.shipDetail?.penaltyCloseEffectiveTime || "00:00"
      })
    }

    this.checkIsPenaltyFormChanged();
  }

  selectedDate(event: any, fieldName) {
    let selectDate = new Date(event);
    let effectiveFormDate = selectDate.getDate().toString().padStart(2, "0") + '.' + (selectDate.getMonth() + 1).toString().padStart(2, "0") + '.' + selectDate.getFullYear();
    if (fieldName == 'effectiveFormDate') {
      this.penaltyForm.patchValue({ effectiveFormDate: effectiveFormDate });
    }
    if (fieldName == 'closeEffectiveDate') {
      this.penaltyForm.patchValue({ closeEffectiveDate: effectiveFormDate });
    }

  }

  addUpdatePenalty(dataList: any) {
    this._vesselService.addUpdatePenaltyData(dataList)
      .subscribe({
        next: (res) => {
          if (res.data.addUpdatePenaltyData.success) {
            this._storageService.putDataInStorage("listReloadAction", "yes");
            this.closePopup();
            this.toasterService.openToast('Success', res.data.addUpdatePenaltyData.message);
          }
        }
      });
  }

  submitPenalty() {
    this.viewModel.submit = true;
    const isFormValid = (): boolean => Object.values(this.penaltyForm.controls).filter(c => c.invalid).length === 0;
    if (!isFormValid()) {
      return;
    }
    let effectiveForm = this.penaltyForm.value.effectiveFormDate.split(".");
    let data = new Date(effectiveForm[2] + '-' + effectiveForm[1] + '-' + effectiveForm[0]);
    let effectiveFormDate = this.datepipe.transform(data, 'yyyy-MM-dd');
    let dataList = {
      vslNumber: this.shipDetail?.vslNumber,
      vslCode: this.shipDetail?.vslCode,
      vslOwner: this.shipDetail?.vslOwner,
      penaltyValue: parseFloat(this.penaltyForm.value.penalty),
      penaltyEffectiveDate: effectiveFormDate,
      penaltyEffectiveTime: this.penaltyForm.value.effectiveFormTime,
      penaltyReason: this.penaltyForm.value.reason,
    };
    if (this.iEditPenaltyForm) {
      let penaltyCloseEffectiveDate: any = '';
      if (this.penaltyForm.value.closeEffectiveDate) {
        let CloseEffectiveDate = this.penaltyForm.value.closeEffectiveDate.split(".");
        let data = new Date(CloseEffectiveDate[2] + '-' + CloseEffectiveDate[1] + '-' + CloseEffectiveDate[0]);
        penaltyCloseEffectiveDate = this.datepipe.transform(data, 'yyyy-MM-dd');
      }

      dataList['penaltyCloseEffectiveDate'] = this.penaltyForm.value.closeEffectiveDate ? penaltyCloseEffectiveDate : null;
      dataList['penaltyCloseEffectiveTime'] = this.penaltyForm.value.closeEffectiveTime;
    }
    this.addUpdatePenalty(dataList);
  }

  onClickClosePenalty(event: any) {
    this.viewModel.isClosePenaltyChecked = event.target.checked;
    if (!event.target.checked) {
      this.penaltyForm.patchValue({
        closeEffectiveDate: '',
        closeEffectiveTime: '00:00',
      })
      this.penaltyForm.controls["closeEffectiveDate"].removeValidators([Validators.required]);
      this.penaltyForm.controls["closeEffectiveTime"].removeValidators([Validators.required]);
    } else {
      this.penaltyForm.controls["closeEffectiveDate"].setValidators([Validators.required]);
      this.penaltyForm.controls["closeEffectiveTime"].setValidators([Validators.required]);
    }
    this.penaltyForm.controls["closeEffectiveDate"].updateValueAndValidity({ onlySelf: true });
    this.penaltyForm.controls["closeEffectiveTime"].updateValueAndValidity({ onlySelf: true });
  }

  public closePopup() {
    this.closePenality.emit(false);
    document.body.style.overflow = "auto";
  }

  public submitPenaltyDisabled() {
    if (!this.viewModel.isPenaltyFormChanged || this.penaltyForm.invalid) {
      return true;
    } else {
      return false;
    }
  }

  checkIsPenaltyFormChanged() {
    const initialValue = this.penaltyForm.value;
    this.penaltyForm.valueChanges.subscribe((formValue) => {
      this.viewModel.isPenaltyFormChanged = Object.keys(initialValue).some(key => this.penaltyForm.value[key] != initialValue[key]);
    })
  }

  setTime(value){
    return this._poolingPortalService.convertTime24to12(value);
  }

  selectedTime(event,fieldName){
    if(fieldName == 'effectiveFormTime'){
      this.penaltyForm.patchValue({ effectiveFormTime: this._poolingPortalService.convertTime12to24(event) });
    }
    if (fieldName == 'closeEffectiveTime') {
      this.penaltyForm.patchValue({ closeEffectiveTime: this._poolingPortalService.convertTime12to24(event) });
    }
  }
}
